import { render, staticRenderFns } from "./DialigBox.vue?vue&type=template&id=7480b1b6&scoped=true&"
import script from "./DialigBox.vue?vue&type=script&lang=js&"
export * from "./DialigBox.vue?vue&type=script&lang=js&"
import style0 from "./DialigBox.vue?vue&type=style&index=0&id=7480b1b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480b1b6",
  null
  
)

export default component.exports